import styled from 'styled-components';

export const StyledShadowContainer = styled.div`
  box-shadow: 0 0 12px 2px rgba(0, 0, 0, 0.5);
  background-color: rgb(50, 55, 62, 0.5);
`;

export const StyledImageContainer = styled.div`
  display: flex;
  max-width: 850px;

  img {
    width: 100%;
  }
`;

export const StyledSoundPlayer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  audio {
    width: 100%;
    height: 40px;
  }
`;

export const StyledScoreSlide = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const StyledScoreHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 100%;
`;

export const StyledScoreQRCode = styled.div`
  display: flex;
  gap: 16px;
  margin-top: auto;

  p:last-of-type {
    font-weight: 300;
  }
`;

export const StyledScoreSoundPlayer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;
